import {
  Button,
  Icon,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { EmployeeHolidayBalance } from '@/types'
import { ROUTES_PATH_PARTS } from '@/constants'

const HOURS_PER_DAY = 8

const formatHoursToDays = (hours: number): string => {
  if (!hours) return '0'

  const sign = hours < 0 ? '-' : ''
  const absHours = Math.abs(hours)
  const days = Math.floor(absHours / HOURS_PER_DAY)
  const remainingHours = Math.round((absHours % HOURS_PER_DAY) * 100) / 100

  if (days > 0 && remainingHours > 0)
    return `${sign}${days}d ${remainingHours}h`
  if (days > 0) return `${sign}${days}d`

  return `${sign}${remainingHours}h`
}

export type HrInternalHoursTableBodyProps = {
  rows: EmployeeHolidayBalance[]
}

export const HrInternalHoursTableBody = ({
  rows,
}: HrInternalHoursTableBodyProps): JSX.Element => {
  const navigate = useNavigate()
  const { t } = useTranslation('hrInternalHours')

  return (
    <TableBody>
      {rows.map((row) => (
        <TableRow key={row.user_id}>
          <TableCell>
            {row.first_name} {row.last_name}
          </TableCell>
          <TableCell>{row.email}</TableCell>
          <TableCell>{row.holiday_balance.year}</TableCell>
          <TableCell>{row.holiday_balance.contract_hours_per_week}h</TableCell>
          <TableCell>{row.holiday_balance.work_percentage}%</TableCell>
          <TableCell>
            {formatHoursToDays(row.holiday_balance.total_holiday_hours)}
          </TableCell>
          <TableCell>
            {formatHoursToDays(row.holiday_balance.used_holiday_hours)}
          </TableCell>
          <TableCell>
            {formatHoursToDays(row.holiday_balance.normal_holiday_hours)}
          </TableCell>
          <TableCell>
            {formatHoursToDays(row.holiday_balance.national_holiday_hours)}
          </TableCell>
          <TableCell>
            {formatHoursToDays(row.holiday_balance.overtime_adjustment)}
          </TableCell>
          <TableCell>
            {formatHoursToDays(row.holiday_balance.cross_years_saldo)}
          </TableCell>
          <TableCell>
            <Typography fontWeight="bold" color="secondary.main">
              {formatHoursToDays(row.holiday_balance.balance)}
            </Typography>
          </TableCell>
          <TableCell align="right">
            <Button
              variant="text"
              onClick={() =>
                navigate(
                  `/${ROUTES_PATH_PARTS.HR_INTERNAL_HOURS}/${row.user_id}`
                )
              }
              endIcon={
                <Icon
                  sx={{ fontSize: 14, lineHeight: '21px', fontWeight: 600 }}
                >
                  <ArrowForwardIcon sx={{ height: 14, width: 14 }} />
                </Icon>
              }
            >
              <Typography variant="body2" fontWeight={600}>
                {t('table.buttons.view')}
              </Typography>
            </Button>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  )
}
